module.exports = __webpack_public_path__ + "img/19_sp.4d2df700.gif";